import { getCardStyles } from '@quno/onboarding/src/generator/configs/componentMapper';
import {
  defaultLocale,
  localeMapper,
} from '@quno/onboarding/src/constants/locales';
import { useTranslation } from '@quno/patient-journey/src/hooks/useTranslation';
import { TextCard } from '@quno/patient-journey/src/components/Card/Variants/TextCard';
import { Base } from '@quno/patient-journey/src/contentful/patient-journey/blocks/Base';
import type { FormLocales } from '@quno/patient-journey/src/constants/locales';
import type { TextContainer } from '@quno/onboarding/src/generator/types/Models';

type TextProps = TextContainer & {
  locale: FormLocales;
};

export const Text = (props: TextProps): JSX.Element => {
  const { locale: pageLocale } = useTranslation();
  const locale = props.locale || localeMapper[pageLocale] || defaultLocale;
  const { attributes } = props ?? {};
  const cardStyles = getCardStyles(props);
  const textCards = attributes?.textCards?.[defaultLocale];

  return (
    <Base {...props}>
      <>
        {textCards?.map((textCard, index) => {
          const { textAlignment: alignment, text } = textCard?.attributes ?? {};
          const textAlignment = alignment?.[defaultLocale] || 'left';

          return (
            <TextCard
              key={index}
              text={text}
              alignment={textAlignment}
              locale={locale}
              backgroundColorOverwrite={cardStyles?.card?.backgroundColor}
              cardBorderRadius={cardStyles?.card?.borderRadius}
              fontColorOverride={cardStyles?.card?.fontColor}
            />
          );
        })}
      </>
    </Base>
  );
};
